import { Flex, Space, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import {
  AutomaticPaymentRemindersDaysSelect,
  AutomaticPaymentRemindersRepeatTypeSelect,
} from '@features/invoicingSettings/modules/paymentsAndReminders'

import { AutomaticPaymentRemindersEmailFields } from '../AutomaticPaymentRemindersEmailFields'

export const AutomaticPaymentRemindersAfterDueDate = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <Flex flexDirection="column">
      <Text weight="bold">
        {t('settings.organization.external_invoice.automatic_payment_reminders.modal.description')}
      </Text>
      <Space size="s8" />
      <Flex alignItems="center" gap={Spacing.S8}>
        <AutomaticPaymentRemindersRepeatTypeSelect />
        <AutomaticPaymentRemindersDaysSelect />
        <Text variant="bodySM" colorVariant="label">
          {t(
            'settings.organization.external_invoice.automatic_payment_reminders.modal.form.after_due_date.description',
          )}
        </Text>
      </Flex>
      <Space size="s16" />
      <AutomaticPaymentRemindersEmailFields />
    </Flex>
  )
}
